'use client'

import { useSession } from '@marketplace-web/shared/session-data'
import { useCountdown } from '@marketplace-web/shared/ui-helpers'

import { ItemPageClosetCountdownActionPluginModel } from './types'
import { useCanTransact } from '../../hooks/useCanTransact'
import ItemCountdownBanner from '../ItemCountdownBanner/ItemCountdownBanner'

type Props = {
  data: ItemPageClosetCountdownActionPluginModel
}

const ItemPageClosetCountdownActionPlugin = ({ data }: Props) => {
  const {
    userId,
    ownerLogin,
    isFollowed,
    endDate,
    isHatePresent,
    canBuy,
    canInstantBuy,
    isReserved,
    isHidden,
    reservedForUserId,
  } = data

  const canTransact = useCanTransact({
    canBuy,
    canInstantBuy,
    isReserved,
    isHidden,
    reservedForUserId,
    closetCountdownEndDate: endDate,
  })
  const currentUserId = useSession().user?.id
  const { isCountdownActive } = useCountdown(endDate)

  const isViewingOwnItem = userId === currentUserId
  const shouldShowCountdownBanner = isViewingOwnItem && isCountdownActive

  if (shouldShowCountdownBanner || !canTransact) {
    return (
      <ItemCountdownBanner
        userId={userId}
        ownerLogin={ownerLogin}
        isFollowed={isFollowed}
        isHatePresent={isHatePresent}
        endDate={endDate}
      />
    )
  }

  return null
}

export default ItemPageClosetCountdownActionPlugin
